import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { IReservationFormSchemaV2 } from "../../../interfaces/reservations/Reservations.types";
import { IReservationPaymentBreakdown } from "../../../interfaces/wallet/Wallet.types";
import { paymentMethods } from "../../bundles/reservations/utils/PaymentsOptions";
import Input from "../../ui/input/Input";
import Select from "../../ui/select/Select";

const GeneralInfo: FC<{
  /** How the booking was paid; names the rail on a credits-funded booking. */
  breakdown?: IReservationPaymentBreakdown;
}> = ({ breakdown }) => {
  const creditsPaid = breakdown?.paidByCredits;
  const {
    register,
    control,
    formState: { errors }
  } = useFormContext<IReservationFormSchemaV2>();

  return (
    <div className="border-t border-gray-200 py-6">
      <div className="px-5">
        <div className="flex justify-between gap-4">
          <Controller
            control={control}
            name="paymentMethod"
            render={({ field: { onChange, value } }) => (
              <Select
                label="Mënyra e pageses"
                // A credits-funded booking carries payment method 0, which the shared option list
                // calls "None" — true of an unpaid booking, misleading here.
                selectedItem={
                  (creditsPaid ?? 0) > 0 && !value?.value
                    ? { label: "Gjirafa Money", value: 0 }
                    : value
                }
                options={paymentMethods}
                disabled
                onSelectedItemChange={(item) => onChange(item)}
              />
            )}
          />
          <Input
            label="Email"
            className="w-full"
            {...register("email")}
            error={errors.email?.message}
          />
          <Input
            label="Numri i telefonit"
            className="w-full"
            {...register("phoneNumber")}
          />
        </div>
      </div>
    </div>
  );
};

export default GeneralInfo;
